export const buildEntitySelectionKey = (fileType, cdmEntityName) =>
  `${fileType || ""}::${cdmEntityName || ""}`;

export const getEntitySelectionKey = (entity) => {
  const cdmEntityName = entity?.cdm_entity_name || entity?.entity_name || "";
  if (!entity?.file_type) return "";
  if (!cdmEntityName) return entity.file_type;
  return buildEntitySelectionKey(entity.file_type, cdmEntityName);
};

export const parseEntitySelectionKey = (selectionKey) => {
  const separatorIndex = String(selectionKey || "").indexOf("::");
  if (separatorIndex < 0) {
    return { fileType: selectionKey || "", cdmEntityName: "" };
  }
  return {
    fileType: selectionKey.slice(0, separatorIndex),
    cdmEntityName: selectionKey.slice(separatorIndex + 2),
  };
};
